import { render, staticRenderFns } from "./DoorLockSocket.vue?vue&type=template&id=12ca8c6e&scoped=true"
import script from "./DoorLockSocket.vue?vue&type=script&lang=js"
export * from "./DoorLockSocket.vue?vue&type=script&lang=js"
import style0 from "./DoorLockSocket.vue?vue&type=style&index=0&id=12ca8c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca8c6e",
  null
  
)

export default component.exports